var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCalendar(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 15.967,
    height: 15.967,
    viewBox: "0 0 15.967 15.967",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "calendar",
    d: "M14.719,10.353V3.742a1.249,1.249,0,0,0-1.247-1.247h-.811v.624a.624.624,0,1,1-1.247,0V2.495H8.576v.624a.624.624,0,0,1-1.247,0V2.495H4.522v.624a.624.624,0,1,1-1.247,0V2.495h-.78A1.249,1.249,0,0,0,1.247,3.742v9.73a1.249,1.249,0,0,0,1.247,1.247H13.472a1.249,1.249,0,0,0,1.247-1.247.624.624,0,0,1,1.247,0,2.5,2.5,0,0,1-2.495,2.495H2.495A2.5,2.5,0,0,1,0,13.472V3.742A2.5,2.5,0,0,1,2.495,1.247h.78V.624a.624.624,0,1,1,1.247,0v.624H7.328V.624a.624.624,0,0,1,1.247,0v.624h2.838V.624a.624.624,0,1,1,1.247,0v.624h.811a2.5,2.5,0,0,1,2.495,2.495v6.611a.624.624,0,1,1-1.247,0Zm-2.058-.468v1.466A1.249,1.249,0,0,1,11.414,12.6H9.948A1.249,1.249,0,0,1,8.7,11.351V9.886A1.249,1.249,0,0,1,9.948,8.638h1.466A1.249,1.249,0,0,1,12.661,9.886Zm-1.247,1.466V9.886H9.948v1.466h1.466Zm0,0",
    fill: "#bcbcbc"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalendar);
export default __webpack_public_path__ + "static/media/calendar.914014bf197da1ab32a45943d3897c07.svg";
export { ForwardRef as ReactComponent };